import {
  SelectProps as MantineSelectProps,
  Select as MantineSelect,
} from '@mantine/core';

export type SelectProps = MantineSelectProps;

export const Select = MantineSelect;

Select.displayName = 'Select';
